import CityBreak from "@/Component/Common/CityBreak";
import CustomerReviews from "@/Component/Common/CustomerReviews";
import DownloadNH from "@/Component/Common/DownloadNH";
import ExclusiveOffers from "@/Component/Common/ExclusiveOffers";
import FeaturedPackage from "@/Component/Common/FeaturedPackage";
import OfferBanner from "@/Component/Common/OfferBanner";
import SeeTheWorld from "@/Component/Common/SeeTheWorld";
import TopDeals from "@/Component/Common/TopDeals";
import UnlockParadises from "@/Component/Common/UnlockParadises";
import MainLayout from "@/Component/MainLayout";
import { withRegionPath } from "@/utils/session";

function resolveOfferBtnUrl(url = "") {
  const trimmed = String(url || "").trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return withRegionPath(trimmed.startsWith("/") ? trimmed : `/${trimmed}`);
}

function mapOfferBannerItems(source) {
  if (!source) return null;

  const list = Array.isArray(source) ? source : [source];
  const mapped = list
    .map((item) => ({
      title: item?.title || "",
      subTitle: item?.subTitle || "",
      btnText: item?.btnText || "",
      btnUrl: resolveOfferBtnUrl(item?.btnUrl),
    }))
    .filter(
      (item) => item.title || item.subTitle || item.btnText || item.btnUrl
    );

  return mapped.length ? mapped : null;
}

export default function HolidayHome({ data = {} }) {
  const homePageHeading = data.initialHomePageHeading;
  const offerItems = mapOfferBannerItems(
    data.initialHomePageAdvertisement ??
      homePageHeading?.advertisement ??
      null
  );

  return (
    <MainLayout
      headerBackgroundImage={homePageHeading?.topBanner?.webImageUrl}
      headerMobileBackgroundImage={homePageHeading?.topBanner?.mobileImageUrl}
    >
      <OfferBanner items={offerItems} />
      <TopDeals initialSeasonalDeals={data.initialSeasonalDeals} />
      <ExclusiveOffers
        initialCouponList={data.initialCouponList}
        defaultModuleId="1"
      />
      <FeaturedPackage initialFeaturedJourney={data.initialFeaturedJourney} />
      <UnlockParadises initialUnlockParadise={data.initialUnlockParadise} />
      <CityBreak initialHolidaysBreaks={data.initialHolidaysBreaks} />
      <CustomerReviews moduleType="Holiday" initialReviewsList={data.initialReviewsList} />
      <DownloadNH />
      <SeeTheWorld
        title={homePageHeading?.heading?.title}
        text={homePageHeading?.heading?.description}
      />
    </MainLayout>
  );
}
